module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "heading": _vm.heading,
      "button-style": "primary",
      "round": _vm.round,
      "button-size": _vm.size,
      "show-text": _vm.showText,
      "button-text": "Add",
      "button-icon": "fa fa-broadcast-tower",
      "disableButton": !(_vm.isTowerSupplierCo() || _vm.isTowerCo()) || !_vm.isManager('project|maintenance|management') || _vm.readOnly || this.isActive
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('struct-details', {
    ref: "sd",
    attrs: {
      "site-id": _vm.siteId,
      "editMode": true,
      "adding": true,
      "hide-panel": true,
      "table-ref": _vm.tableRef,
      "read-only": _vm.readOnly
    },
    on: {
      "update": _vm.updatedStruct
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01687784"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/StructureAction.vue
// module id = 1385
// module chunks = 0